import { library } from "@fortawesome/fontawesome-svg-core";
import { 
    faUser,
    faEnvelope,
    faLock,
} from "@fortawesome/free-solid-svg-icons";
import { 
    faFacebookSquare
} from "@fortawesome/free-brands-svg-icons";

library.add(faUser);
library.add(faEnvelope);
library.add(faLock);
library.add(faFacebookSquare);